import { useEffect, useState } from "react";
import axios from "axios";
import { MapPin } from "lucide-react";
import { getBackendUrl } from "@/lib/backend";
import { getManagementLabel, getCategoryLabel } from "@/lib/sqaafLabels";

const API = `${getBackendUrl()}/api`;

export default function SqafFilterBar({
  blockFilter,
  clusterFilter,
  managementFilter,
  categoryFilter,
  onBlockChange,
  onClusterChange,
  onManagementChange,
  onCategoryChange,
  onClear,
  filterContext,
  nQuestions = 128,
  variant = "scope",
}) {
  const [options, setOptions] = useState({ blocks: [], clusters: [], school_management: [], school_category: [] });

  useEffect(() => {
    axios
      .get(`${API}/sqaaf/filters`, { params: { block: blockFilter || undefined } })
      .then((res) =>
        setOptions({
          blocks: [],
          clusters: [],
          school_management: [],
          school_category: [],
          ...(res.data || {}),
        })
      )
      .catch(() => setOptions({ blocks: [], clusters: [], school_management: [], school_category: [] }));
  }, [blockFilter]);

  const hasFilters = blockFilter || clusterFilter || managementFilter || categoryFilter;
  const n = filterContext?.n_schools ?? options.n_schools ?? 0;

  if (variant === "scope") {
    return (
      <section className="scope-card" aria-label="Dashboard filters" data-testid="sqaf-filter-bar">
        <div className="filter-row">
          <span className="filter-chip">
            <MapPin className="svg-icon" strokeWidth={2} />
            Scope <b>District</b>
          </span>
          <label className="filter-chip">
            District <b>Pune</b>
          </label>
          <label className="filter-chip">
            Block{" "}
            <b>
              <select
                className="sqaf-scope-select"
                value={blockFilter || "All"}
                onChange={(e) => onBlockChange(e.target.value === "All" ? "" : e.target.value)}
                aria-label="Filter by block"
              >
                <option value="All">All</option>
                {(options.blocks || []).map((b) => (
                  <option key={b} value={b}>
                    {b}
                  </option>
                ))}
              </select>
            </b>
          </label>
          {blockFilter ? (
            <label className="filter-chip">
              Cluster{" "}
              <b>
                <select
                  className="sqaf-scope-select"
                  value={clusterFilter || "All"}
                  onChange={(e) => onClusterChange(e.target.value === "All" ? "" : e.target.value)}
                  aria-label="Filter by cluster"
                >
                  <option value="All">All</option>
                  {(options.clusters || []).map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </b>
            </label>
          ) : null}
          <label className="filter-chip">
            Management{" "}
            <b>
              <select
                className="sqaf-scope-select"
                value={managementFilter || "All"}
                onChange={(e) => onManagementChange(e.target.value === "All" ? "" : e.target.value)}
                aria-label="Filter by management"
              >
                <option value="All">All</option>
                {(options.school_management || []).map((m) => (
                  <option key={m} value={m}>
                    {getManagementLabel(m)}
                  </option>
                ))}
              </select>
            </b>
          </label>
          <label className="filter-chip">
            Category{" "}
            <b>
              <select
                className="sqaf-scope-select"
                value={categoryFilter || "All"}
                onChange={(e) => onCategoryChange(e.target.value === "All" ? "" : e.target.value)}
                aria-label="Filter by category"
              >
                <option value="All">All</option>
                {(options.school_category || []).map((c) => (
                  <option key={c} value={c}>
                    {getCategoryLabel(c)}
                  </option>
                ))}
              </select>
            </b>
          </label>
          <span className="filter-chip">
            Questions <b>{nQuestions}</b>
          </span>
          {hasFilters ? (
            <button type="button" className="ghost-action" onClick={onClear} data-testid="sqaaf-clear-filters">
              Clear
            </button>
          ) : null}
        </div>
        <div className="scope-note">
          Active: Pune District · {n.toLocaleString()} schools · MongoDB source
        </div>
      </section>
    );
  }

  return (
    <div className="sqaf-filter-panel" data-testid="sqaf-filter-bar">
      <div className="filter-row">{/* legacy panel unused in v3 */}</div>
    </div>
  );
}
